import React, { useState } from "react";
import {
  formatDisplayDate,
  formatDisplayTime,
  calculateNights,
  groupBookingRecordsByDateCombinations,
  getGroupStatus,
  countBookingIntentTriggered,
} from "../../utils/bookingHistoryUtils";
import BookingDetailsModal from "./BookingDetailsModal";

const BookingHistory = ({ records, formatTimeAgo }: any) => {
  const [selectedGroup, setSelectedGroup] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  // Group booking records by date combinations
  const bookingGroups = groupBookingRecordsByDateCombinations(records);

  if (bookingGroups.length === 0) {
    // Check if there are any booking_intent_triggered actions
    const bookingIntentCount = countBookingIntentTriggered(records);
    
    if (bookingIntentCount > 0) {
      return (
        <div className="text-center py-4">
          <p className="text-muted small">
            Booking was initiated {bookingIntentCount} {bookingIntentCount === 1 ? "time" : "times"}.
          </p>
        </div>
      );
    }
    
    return (
      <div className="text-center py-4">
        <p className="text-muted small">No booking history found.</p>
      </div>
    );
  }

  const handleCardClick = (group, attemptNumber) => {
    setSelectedGroup({ group, attemptNumber });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedGroup(null);
  };

  // Get summary of actions in a group
  const getGroupSummary = (group) => {
    const actions = group.records.map((r) => r.bookingData.action);
    const summary = [];

    if (actions.includes("booking_confirmed")) {
      summary.push("Confirmed");
    } 
    // else if (actions.includes("room_selected")) {
    //   summary.push("Room Selected");
    // } 
    else if (actions.includes("offer_selected")) {
      summary.push("Offer Selected");
    } else if (actions.includes("occupancy_selected")) {
      summary.push("Occupancy Selected");
    } else if (actions.includes("rooms_presented")) {
      const roomsPresented = group.records.find((r) => r.bookingData.action === "rooms_presented");
      if (roomsPresented?.bookingData?.data?.rooms_available === false) {
        summary.push("No Availability");
      } else {
        summary.push("Rooms Available");
      }
    } else if (actions.includes("dates_selected")) {
      summary.push("Dates Selected");
    }

    return summary.join(" • ");
  };

  // Get the last action icon
  // const getLastActionIcon = (group) => {
  //   const lastAction = group.records[group.records.length - 1]?.bookingData?.action;
  //   switch (lastAction) {
  //     case "booking_confirmed":
  //       return "bi-check-circle-fill text-success";
  //     // case "room_selected":
  //     //   return "bi-check-circle text-success";
  //     case "occupancy_selected":
  //       return "bi-people text-info";
  //     case "rooms_presented":
  //       const roomsPresented = group.records.find((r) => r.bookingData.action === "rooms_presented");
  //       if (roomsPresented?.bookingData?.data?.rooms_available === false) {
  //         return "bi-x-circle text-danger";
  //       }
  //       return "bi-bed text-primary";
  //     case "dates_selected":
  //       return "bi-calendar3 text-primary";
  //     default:
  //       return "bi-circle text-secondary";
  //   }
  // };

  return (
    <>
      <div className="booking-history-compact">
        {bookingGroups.map((group, groupIndex) => {
          const groupStatus = getGroupStatus(group);
          const attemptNumber = bookingGroups.length - groupIndex;
          const summary = getGroupSummary(group);
          // const lastActionIcon = getLastActionIcon(group);

          return (
            <div
              key={group.groupKey}
              className="booking-attempt-card-compact"
              onClick={() => handleCardClick(group, attemptNumber)}
            >
              <div className="d-flex align-items-center gap-3">
                {/* Number Badge */}
                <div className="booking-attempt-number">
                  {attemptNumber}
                </div>

                {/* Main Content */}
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <h6 className="mb-0 fw-semibold">Booking Attempt #{attemptNumber}</h6>
                    <div className="d-flex align-items-center gap-2">
                      {/* <span className={`badge bg-${groupStatus.color}-subtle text-${groupStatus.color}`}>
                        {groupStatus.label}
                      </span> */}
                      {group.latestTime && (
                        <span className="text-muted small">
                          <i className="bi bi-clock me-1"></i>
                          {formatDisplayDate(group.latestTime)} {formatDisplayTime(group.latestTime)}
                        </span>
                      )}
                    </div>
                  </div>
                  {group.checkinDate && group.checkoutDate && (
                    <div className="small text-muted mb-1">
                      <i className="bi bi-calendar3 me-1"></i>
                      {formatDisplayDate(group.checkinDate)} - {formatDisplayDate(group.checkoutDate)}
                      <span className="ms-2">
                        ({calculateNights(group.checkinDate, group.checkoutDate)}{" "}
                        {calculateNights(group.checkinDate, group.checkoutDate) === 1 ? "night" : "nights"})
                      </span>
                    </div>
                  )}
                  {/* Action Count */}
                  <div className="small text-muted">
                    {group.records.length} {group.records.length === 1 ? "action" : "actions"}
                    <i className="bi bi-chevron-right ms-2"></i>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal */}
      {selectedGroup && (
        <BookingDetailsModal
          show={showModal}
          onHide={handleCloseModal}
          group={selectedGroup.group}
          attemptNumber={selectedGroup.attemptNumber}
        />
      )}
    </>
  );
};

export default BookingHistory;
